import { Injectable } from '@angular/core';

declare var $: any;

@Injectable()
export class NotificationService {

	constructor() { }

	showNotification(message: string, title: string = "", type: string = "success") {
		$("button[data-notify='dismiss']").click();
		$.notify({
			icon: 'notifications',
			message: message,
			title: title
		}, {
				type: type,
				timer: 3000,
				placement: {
					from: 'bottom',
					align: 'right'
				}
			});
	}

}



// WEBPACK FOOTER //
// ./src/app/services/NotificationService.ts